import FindControlViewState from '../store/schema/FindControlViewState';
import transactionFailed from 'owa-controls-findpeople-feedback-manager/lib/actions/transactionFailed';
import { OwaDate } from 'owa-datetime';

/**
 * Adds a relevance api transaction complete feedback
 */
export default function addTransactionFailed(
    recipientWellViewState: FindControlViewState,
    transactionRequestTime: OwaDate
) {
    let context = {
        Action: 'Type Down',
    };

    transactionFailed(
        recipientWellViewState.findPeopleFeedbackManager,
        recipientWellViewState.queryString,
        recipientWellViewState.findResultTransactionId,
        transactionRequestTime,
        context
    );
}
